import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class PaginationNext extends PureComponent {
    render() {
        const {
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['ml-auto']: true
        });

        return (
            <div className={classNames} {...props}>
                {children}
            </div>
        );
    }
}

PaginationNext.defaultProps = {};

export default PaginationNext;
